import { RefreshCw } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { clearGlobalError } from "../slices/error.slice";
import { getGlobalErrorContent } from "../helpers/error.helper";

export default function GlobalErrorScreen() {
    const dispatch = useAppDispatch();

    const error = useAppSelector((state) => state.app?.error);

    const {
        title,
        description,
        status,
        icon: Icon,
        buttonText,
    } = getGlobalErrorContent(error);

    return (
        <div className="flex h-full min-h-[70vh] items-center justify-center p-6">
            <div className="w-full max-w-xl rounded-2xl border border-gray-200 bg-white p-10 shadow-sm">
                <div className="flex flex-col items-center text-center">
                    <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
                        <Icon className="h-8 w-8 text-red-600" />
                    </div>

                    <span className="rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-600">
                        {status}
                    </span>

                    <h2 className="mt-4 text-2xl font-semibold text-gray-900">
                        {title}
                    </h2>

                    <p className="mt-3 max-w-md text-gray-500">
                        {description}
                    </p>

                    <button
                        onClick={() => {
                            dispatch(clearGlobalError());
                            window.location.reload();
                        }}
                        className="mt-8 inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-3 text-white transition hover:opacity-90"
                    >
                        <RefreshCw className="h-4 w-4" />
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
}